import { motion } from 'framer-motion';

import {
  imgStyle,
  inlineContainerStyle,
  nameStyle,
  reactionButtonStyle,
  textStyle
} from '@/components/Likes/LikeCard/styles.ts';
import { MAX_NAME_LENGTH } from '@/components/Likes/LikesList.tsx';
import { CandidateProfilePhotosDto } from '@/api/matchmaker/types.ts';
import { helpers } from '@/helpers.ts';
import { ImageWithLoader } from '@/components/common/Image/ImageWithLoader.tsx';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';

const SentLikesCard = ({
  imgUrl,
  name,
  age,
  onClick,
  onSendReaction
}: {
  imgUrl?: CandidateProfilePhotosDto;
  name: string;
  age: number;
  onClick: () => void;
  onSendReaction: () => void;
}) => {
  const truncatedName =
    name.length > MAX_NAME_LENGTH
      ? name.slice(0, MAX_NAME_LENGTH) + '...'
      : name;

  return (
    <>
      <div
        style={{ position: 'relative', width: '100%', height: '220px' }}
        onClick={onClick}
      >
        <ImageWithLoader
          key={helpers.getPrimaryPhoto(imgUrl?.variants ?? [])}
          src={helpers.getPrimaryPhoto(imgUrl?.variants ?? []) ?? ''}
          thumbhash={helpers.getThumbHash(imgUrl?.variants ?? [])}
          fallbackIconHeight={65}
          fallbackIconWidth={50}
          alt=""
          style={imgStyle}
        />
      </div>
      <div style={nameStyle} onClick={onClick}>
        <div style={inlineContainerStyle}>
          <span style={textStyle}>
            {truncatedName}
            {age !== 0 ? `, ${age}` : ''}
          </span>
          <VerifiedBadgeShape
            width={18}
            height={18}
            style={{ marginLeft: 3 }}
          />
        </div>
      </div>
      <motion.div
        style={reactionButtonStyle}
        onClick={onSendReaction}
        whileTap={{
          scale: 0.8,
          transition: { type: 'spring', stiffness: 300, damping: 10 }
        }}
      >
        <FireReactionShape
          fillColor="#fff"
          width={22}
          height={22}
          style={{ marginBottom: '2px', marginRight: '2px' }}
        />
      </motion.div>
    </>
  );
};

export default SentLikesCard;
